const based = '.based.dev/'

export const parseContestantImageSrc = (src: string, w: number) => {
  const targetSize = Math.min(1920, w * 2)

  if (src?.includes(based) && !src.includes(`${based}cdn-cgi/image/`)) {
    src = src.replace(
      based,
      `${based}cdn-cgi/image/w=${targetSize},h=${targetSize},gravity=face,fit=crop/`,
    )
  }
  return src
}
